import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTop from '../../components/feature/ScrollToTop';
import ProjectsHero from './components/ProjectsHero';
import ProjectsGallery from './components/ProjectsGallery';
import { useSEO } from '../../utils/seo';

const ProyectosPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hormipremium.com';

  useSEO({
    title: 'Proyectos Hormigón Decorativo Estepona | Galería HORMI PREMIUM',
    description: 'Descubre nuestros proyectos de hormigón decorativo en Estepona y Costa del Sol. Galería de trabajos realizados: hormigón impreso, pulido, desactivado y piscinas Arelite.',
    keywords: 'proyectos hormigón decorativo, galería hormigón impreso, trabajos realizados Estepona, piscinas Arelite Costa del Sol',
    canonical: `${siteUrl}/proyectos`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'Proyectos de Hormigón Decorativo',
      description: 'Galería de proyectos realizados por HORMI PREMIUM en Estepona y Costa del Sol',
      provider: {
        '@type': 'LocalBusiness',
        name: 'HORMI PREMIUM',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Estepona',
          addressRegion: 'Andalucía',
          addressCountry: 'ES',
        },
        telephone: '+34640877479',
      },
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        <ProjectsHero />
        <ProjectsGallery />
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTop />
    </div>
  );
};

export default ProyectosPage;
